const products = [
  {
    id: 1,
    name: "Shoes",
    productType: "Running shoes",
    price: 50,
    rating: 4,
    image:
      "https://s2.r29static.com/bin/entry/ebd/0,675,2000,1050/x,80/1929471/image.jpg",
    description:
      "Nike Air is our iconic innovation that uses pressurized air in a durable, flexible membrane to provide lightweight cushioning. The air compresses on impact and then immediately returns to its original shape and volume, ready for the next impact. We debuted Nike Air in 1979, and we've been continuously evolving and improving it ever since.",
  },
  {
    id: 2,
    name: "Macbook",
    productType: "Apple Mcbook",
    price: 1000,
    rating: 4,
    image:
      "https://cnet3.cbsistatic.com/img/yjrw7VgWV7a95AvK8Ym0Np4bFXY=/1200x675/2017/06/27/13484418-bfd9-41e2-8f2d-9b4afb072da8/apple-macbook-pro-15-inch-2017-14.jpg",
    description:
      "Apple MacBook Pro is a macOS laptop with a 13.30-inch display that has a resolution of 2560x1600 pixels. It is powered by a Core i5 processor and it comes with 12GB of RAM. The Apple MacBook Pro packs 512GB of SSD storage.",
  },
  {
    id: 3,
    name: "Coffee Maker",
    productType: "L14dc19 Black Filter Coffee Machine",
    price: 28,
    rating: 3,
    image:
      "https://brain-images-ssl.cdn.dixons.com/4/9/10189494/u_10189494.jpg",
    description:
      "Coffeemakers or coffee machines are cooking appliances used to brew coffee. While there are many different types of coffeemakers using several different brewing principles, in the most common devices, coffee grounds are placed into a paper or metal filter inside a funnel, which is set over a glass or ceramic coffee pot, a cooking pot in the kettle family.",
  },
  {
    id: 4,
    name: "Sweater",
    productType: "Xbox Christmas Sweater",
    price: 42,
    rating: 5,
    image:
      "https://merchoidcdn-pveiw4zwh96ot9z.netdna-ssl.com/media/catalog/product/cache/65c63282a2b3bd0da0ec5b004bcde549/x/b/xbox-jumper.jpg",
    description:
      "PC or Mac. Pepsi or Coke. Xbox or…that other console. It isn’t always easy to show your allegiances, especially when you’re bundled up for the holidays, but this jumper will let you make it abundantly clear what type of games you want to find under your tree.",
  },
];

export default products;
